import React, { useState, useEffect, useCallback, useRef } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { CardTask } from "../../../../components/CardTask";
import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useAuth } from "../../../../hooks/useAuth";
// import { useNotification } from "../../../../hooks/useNotification";
import { useTranslate } from "../../../../hooks/useTranslate";
import { tasks } from "../../../../services/tasks";
import { formatDate } from "../../../../utils/format-date";
import { ItemsHeader, StatusTask } from "../../enum";
import { ITask } from "../../interface";
import {
  Container,
  Content,
  ContentTasks,
  CountTasks,
  Header,
  ItemCountTasks,
  ItemHeader,
  ItemLastTask,
  LastFinishedTask,
  ResumeTasks,
  TitleLastFinishedTasks,
  TitleResumeTasks,
  ViewPendingTasks,
  ListCards,
  WrapperTasks,
  WithoutTasks,
} from "./styles";

const List = () => {
  const navigate = useNavigate();
  // const { errorNotification } = useNotification();
  const { translate } = useTranslate();
  const { propertiesIds } = useAuth();

  const [optionHeader, setOptionHeader] = useState<ItemsHeader>(
    ItemsHeader.HIGHLIGHTS
  );
  const [countTasks, setCountTasks] = useState({
    totalNewTasks: 0,
    totalPendingTasks: 0,
  });
  const [newTasks, setNewTasks] = useState<ITask[]>([]);
  const [pendingTasks, setPendingTasks] = useState<ITask[]>([]);
  const [finishedTasks, setFinishedTasks] = useState<ITask[]>([]);

  const boot = useCallback(async () => {
    try {
      const allTasks: ITask[] = [];
      const page = 1;
      const limit = 10000;

      const { data } = await tasks({
        page,
        limit,
        idFarm: propertiesIds[0],
      });

      allTasks.push(...data);

      // if (meta.pages > 1) {
      //   for (let index = page + 1; index <= meta.pages; index++) {
      //     const { data } = await tasks({
      //       page: index,
      //       limit,
      //       idFarm: propertiesIds[0],
      //     });
      //     allTasks.push(...data);
      //   }
      // }

      const tasksFormatted = allTasks.map((task) => {
        let taskFinishedDate = "";

        if (task.finished_at != null)
          taskFinishedDate = formatDate(new Date(task.finished_at));
        return {
          ...task,
          taskCreationDate: formatDate(new Date(task.createdAt)),
          taskFinishedDate,
        };
      });

      const newTasks = tasksFormatted.filter(
        (task) => task.status.toUpperCase() === StatusTask.NEW
      );
      const pendingTasks = tasksFormatted.filter(
        (task) =>
          task.status.toUpperCase() === StatusTask.PENDING ||
          task.status.toUpperCase() === StatusTask.NEW
      );
      const finishedTasks = tasksFormatted.filter(
        (task) => task.status.toUpperCase() === StatusTask.FINISHED
      );

      setCountTasks({
        totalNewTasks: newTasks.length,
        totalPendingTasks: pendingTasks.length,
      });
      setPendingTasks(pendingTasks);
      setFinishedTasks(finishedTasks);
      setNewTasks(newTasks);
    } catch {
      // errorNotification(translate("tasks.error_load_tasks"));
    }
  }, [propertiesIds]);

  const ready = useRef(false);

  useEffect(() => {
    if (!ready.current) {
      ready.current = true;
      if (propertiesIds.length > 0) boot();
    }
  }, [boot, propertiesIds.length]);

  return (
    <Container>
      <HeaderTitle
        title={translate("tasks.title_list")}
        showPlus
        urlPlus="/tasks/create"
      />
      <Header>
        <ItemHeader
          onClick={() => {
            setOptionHeader(ItemsHeader.HIGHLIGHTS);
          }}
          currentStep={optionHeader === ItemsHeader.HIGHLIGHTS}
        >
          {translate("tasks.item_header_1")}
        </ItemHeader>
        {/* <ItemHeader
          onClick={() => {
            setOptionHeader(ItemsHeader.NEWS);
          }}
          currentStep={optionHeader === ItemsHeader.NEWS}
        >
          {translate("tasks.item_header_2")}
        </ItemHeader> */}
        <ItemHeader
          onClick={() => {
            setOptionHeader(ItemsHeader.OUTSTANDING);
          }}
          currentStep={optionHeader === ItemsHeader.OUTSTANDING}
        >
          {translate("tasks.item_header_3")}
        </ItemHeader>
        <ItemHeader
          onClick={() => {
            setOptionHeader(ItemsHeader.FINISHED);
          }}
          currentStep={optionHeader === ItemsHeader.FINISHED}
        >
          {translate("tasks.item_header_4")}
        </ItemHeader>
      </Header>

      <Content>
        {optionHeader === ItemsHeader.HIGHLIGHTS && (
          <WrapperTasks>
            <ResumeTasks>
              <ContentTasks>
                <TitleResumeTasks>
                  {translate("tasks.title_resume")}
                </TitleResumeTasks>
                <CountTasks>
                  <ItemCountTasks color="black">
                    <p>{countTasks.totalNewTasks}</p>
                    <span>{translate("tasks.tasks_status_1")}</span>
                  </ItemCountTasks>
                  <ItemCountTasks color="primary">
                    <p>{countTasks.totalPendingTasks}</p>
                    <span>{translate("tasks.tasks_status_2")}</span>
                  </ItemCountTasks>
                </CountTasks>
                <ViewPendingTasks
                  onClick={() => {
                    setOptionHeader(ItemsHeader.OUTSTANDING);
                  }}
                >
                  {translate("tasks.view_pending_tasks")}
                  <FiChevronRight size={22} />
                </ViewPendingTasks>
              </ContentTasks>
            </ResumeTasks>
            <LastFinishedTask>
              <TitleLastFinishedTasks>
                {translate("tasks.view_finished_tasks")}
              </TitleLastFinishedTasks>
              {finishedTasks.length > 0 ? (
                finishedTasks.slice(0, 3).map((task) => (
                  <ItemLastTask
                    onClick={() => {
                      navigate(`/tasks/history/${task.id}`);
                    }}
                    key={task.id}
                  >
                    <img src={task.photo} alt={task.description.slice(0, 20)} />
                    <div>
                      <p>{task.description}</p>
                      <span>
                        {translate("tasks.in")} {task.taskFinishedDate} por{" "}
                        {task.creatorName || translate("global.uninformed")}
                      </span>
                    </div>
                  </ItemLastTask>
                ))
              ) : (
                <WithoutTasks>{translate("global.title_empty")}</WithoutTasks>
              )}
            </LastFinishedTask>
          </WrapperTasks>
        )}

        {/* {optionHeader === ItemsHeader.NEWS && (
          <ListCards>
            {newTasks.length > 0 ? (
              newTasks.map((task) => (
                <CardTask
                  url={`/tasks/history/${task.id}`}
                  key={task.id}
                  {...task}
                />
              ))
            ) : (
              <WithoutTasks>{translate("global.title_empty")}</WithoutTasks>
            )}
          </ListCards>
        )} */}

        {optionHeader === ItemsHeader.OUTSTANDING && (
          <ListCards>
            {pendingTasks.length > 0 ? (
              pendingTasks.map((task) => (
                <CardTask
                  url={`/tasks/history/${task.id}`}
                  key={task.id}
                  {...task}
                />
              ))
            ) : (
              <WithoutTasks>{translate("global.title_empty")}</WithoutTasks>
            )}
          </ListCards>
        )}

        {optionHeader === ItemsHeader.FINISHED && (
          <ListCards>
            {finishedTasks.length > 0 ? (
              finishedTasks.map((task) => (
                <CardTask
                  url={`/tasks/history/${task.id}`}
                  key={task.id}
                  {...task}
                />
              ))
            ) : (
              <WithoutTasks>{translate("global.title_empty")}</WithoutTasks>
            )}
          </ListCards>
        )}
      </Content>
    </Container>
  );
};

export { List };
